<template>
  <div>
    <SeatMapBottomSheet
      :name="name"
      :flight="flight"
      :seat-map-queries="seatMapQueries"
      :passengers-data="passengersData"
      :seat-map-state-by-flight="seatMapStateByFlight"
      :passengers-keys="passengersKeys"
      @onCommitState="emit('onCommitState', $event)"
      @onTryToClose="onBeforeBottomSheetClose"
    />
    <ConfirmationModal
      modal-name="save-seat-map-state-warning-modal"
      @onAgree="bottomSheet.hide(name)"
    />
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { ConfirmationModal, flightEntity } from 'freedom-shared';
  import { controllerModel } from 'shared';
  import type { QueryObserverResult } from '@tanstack/vue-query';
  import type { AxiosResponse } from 'axios';
  import type { Airflow } from '@aviata/platform-types';
  import type { PassengerKey, PassengersData } from '@aviata/booking-data';

  import { SeatMapBottomSheet } from './ui';
  import type { SelectedSeatsState } from './types';

  defineProps<{
    name: string;
    flight: flightEntity.types.MappedFlight;
    seatMapQueries: QueryObserverResult<
      AxiosResponse<Airflow.SeatMap.Entity>
    >[];
    passengersData: PassengersData;
    seatMapStateByFlight: SelectedSeatsState;
    passengersKeys: PassengerKey[];
  }>();

  const emit = defineEmits<{
    onCommitState: [SelectedSeatsState];
  }>();

  const modal = controllerModel.useModal();
  const bottomSheet = controllerModel.useBottomSheet();
  const { t } = useI18n();

  function onBeforeBottomSheetClose() {
    modal.show('save-seat-map-state-warning-modal', {
      message: t('ancillaries.seatMap.saveWarning.message'),
      title: t('ancillaries.seatMap.saveWarning.title'),
    });
  }
</script>
